export const Footer = ({ FooterComponent, ...rest }) => (
  <FooterComponent {...rest} />
);
